import fetch from 'cross-fetch';

const fn = {};

function urlParam(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
    window.location.search
  );

  return results !== null ? results[1] || 0 : false;
}

fn.verifyRecoveryCode = async function(baseUrl, answer, authUserId) {
  try {
    const res = await fetch(baseUrl + '/login/backupcodes', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code: answer,
        loginChallenge: urlParam('login_challenge'),
        authUserId,
      }),
    });
    if (res.status !== 200) {
      throw new Error('error occured');
    }
    const user = await res.json();
    if (!user?.code) {
      throw new Error('invalid response');
    }
    return user?.code;
  } catch (error) {
    throw new Error(error.message || 'error occured');
  }
};

export default fn;
